import { useState } from "react";
import { DepositModal } from "./DepositModal";
import { ButtonPrimary } from "../../components/NewButtons";

export const DepositSelector = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ButtonPrimary
        type="button"
        height="fit-content"
        onClick={(e) => {
          setIsOpen(true);
        }}
        className="w-fit"
      >
        Deposit
      </ButtonPrimary>
      <DepositModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
    </>
  );
};
